module.exports = __webpack_public_path__ + "img/other_avatar-min.3150ebf0.png";